__turbopack_context__.v({
  "activeTab": "STNewsFeed-module__QV4Kyq__activeTab",
  "emptyIcon": "STNewsFeed-module__QV4Kyq__emptyIcon",
  "emptyState": "STNewsFeed-module__QV4Kyq__emptyState",
  "newsCard": "STNewsFeed-module__QV4Kyq__newsCard",
  "newsCardWrapper": "STNewsFeed-module__QV4Kyq__newsCardWrapper",
  "newsImageWrap": "STNewsFeed-module__QV4Kyq__newsImageWrap",
  "newsTitle": "STNewsFeed-module__QV4Kyq__newsTitle",
  "tab": "STNewsFeed-module__QV4Kyq__tab",
  "tabs": "STNewsFeed-module__QV4Kyq__tabs",
  "viewToggle": "STNewsFeed-module__QV4Kyq__viewToggle",
});
